import { controls } from "../../../controls"

const rp751 = {
  label: "NPA Register",
  starting: true,
  url: "rp751",
  pageLabel: "NPA Register",
  pageType: "history",
  form: [],
  filter: [
    ...controls.displayText({ tab: "filter", label: "Region", width: "col-sm-2" }),
    ...controls.Region({ tab: "filter", }),
    ...controls.showData({ tab: "filter", name: "region_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "Purpose", width: "col-sm-2" }),
    ...controls.Purpose({ tab: "filter", width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", name: "purpose_display", data: "purpose_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch", width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", }),
    ...controls.displayText({ tab: "filter", label: "Priority ", width: "col-sm-2" }),
    ...controls.PrioritySector({ tab: "filter", width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", name: "priority_sector_display", data: "priority_sector_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "Product Type", width: "col-sm-2" }),
    ...controls.ProductType({
      tab: "filter",
    }),
    ...controls.showData({ tab: "filter", data: "product_type_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Security", width: "col-sm-2" }),
    ...controls.Security({ tab: "filter", width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", name: "security_display", data: "security_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "GL Sub Head", width: "col-sm-2" }),
    ...controls.product({ tab: "filter", }),
    ...controls.showData({ tab: "filter", data: "product_code_display", name: "product_code_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "Occupation", width: "col-sm-2" }),
    ...controls.Occupation({ tab: "filter" }),
    ...controls.showData({ tab: "filter", data: "occupation_display", name: "occupation_display", width: "col-sm-2" }),
    ...controls.magicDateLabel({ tab: "filter", star: true, label: "As On Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", isRequired: true, dateType: "ontype", name: "as_on_date", width: "col-sm-2", default: "sessiondate" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "Account Type", width: "col-sm-2 " }),
    ...controls.AccountType({ tab: "filter", width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", data: "account_type_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "NPA Status", width: "col-sm-2" }),
    ...controls.NpaStatus({ tab: "filter" }),
    ...controls.showData({ tab: "filter", width: "col-sm-2", data: "npa_status_display" }),
    ...controls.displayText({ tab: "filter", label: "Industry Type", width: "col-sm-2" }),
    ...controls.IndustryType({ tab: "filter", width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", name: "industrytype_display", data: "industrytype_display", width: "col-sm-2" }),
    ...controls.magicDateLabel({ tab: "filter", label: "Open Date From-To", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "open_from_date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "open_to_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Loan Action", width: "col-sm-2" }),
    ...controls.LoanAction({ tab: "filter" }),
    ...controls.showData({ tab: "filter", width: "col-sm-2", data: "loan_action_display" }),

    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Sanction Amount From-To",
      name: "",
      description: ""
    },
    {
      inputType: "numberonly",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "saction_amount_from",
      description: ""
    },
    {
      inputType: "numberonly",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "saction_amount_to",
      description: ""
    },
    ...controls.displayText({ tab: "filter", label: "Priority Sector", width: "col-sm-2" }),
    ...controls.PrioritySector({ tab: "filter", width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", name: "priority_sector_display", data: "priority_sector_display", width: "col-sm-2" }),
    ...controls.magicDateLabel({ tab: "filter", label: "Collection Date Form-To", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "collectin_date_form", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "collectin_date_to", width: "col-sm-2" }),

    {
      inputType: "checkbox",
      tab: "filter",

      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Sort on A/C no",
      name: "isSortOnAcNo",
      description: ""
    },
    {
      inputType: "checkbox",
      tab: "filter",

      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Print Provision",
      name: "isPrintprovision",
      description: ""
    },
    {
      inputType: "checkbox",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Print Loan Action",
      name: "isPrintloanaction",
      description: ""
    },
    ...controls.displayText({ tab: "filter", label: "Collection Amount From-To", width: "col-sm-2" }),

    {
      inputType: "text",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "collection_amount_from",
      description: ""
    },
    {
      inputType: "text",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "collection_amount_from",
      description: ""
    },



    {
      inputType: "checkbox",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Detail Balances",
      name: "isDetailbalance",
      description: ""
    },
    {
      inputType: "checkbox",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Print Security",
      name: "isPrintsecurity",
      description: ""
    },
    {
      inputType: "checkbox",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Print Marathi",
      name: "isPrintMarathi",
      description: ""
    },

    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Balance/Interest",
      name: "",
      description: ""
    },
    {
      inputType: "select",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [],
      placeHolder: "",
      label: "",
      name: "balanceinterest",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "checkbox",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Print CIN",
      name: "printcin",
      description: ""
    },
  ],
  history: {
    perPage: 10,
    reportHeader: "Deposit Accounts",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [

      {
        Header: "A/C No",
        accessor: "account_number",
        width: 150
      },

      {
        Header: "CIN",
        accessor: "cin",
      },
      {
        Header: "Description",
        accessor: "description",
      },
      {
        Header: "NPA Status",
        accessor: "npastatus",
      },
      {
        Header: "Open Date",
        accessor: "open_date",
      },
      {
        Header: "Expiry Date",
        accessor: "expirydate",
      },
      {
        Header: "Sanction Amount",
        accessor: "sanction_amount",
        type: "currency",

      },

    ]
  }
}
export default rp751
